const FORM_URL = 'https://my.wolrus.org/forms/home_group';

export const getFormUrl = leader => `${FORM_URL}?leader=${leader}`;
